/**
 * Dashboard SPA entrypoint.
 *
 * Mounts the Vue app at `#app`, wires the router, and kicks off
 * loading the `<lucent-insight>` runtime bundle from the configured
 * insights-api host. The runtime bundle registers itself globally
 * (no awaits needed in templates) so any view can render
 * `<lucent-insight ...>` once it loads.
 */

import { createApp } from "vue";
import App from "./App.vue";
import { router } from "./router.ts";
import { bootstrapRuntime } from "./runtime-loader.ts";

// Global styles, shared with insights-admin via `@lucent/ui` — one source of
// truth rather than two copies that drift. `tokens.css` first: `chrome.css`
// reads its custom properties, and an undefined one invalidates the whole
// declaration rather than falling back.
import "@lucent/ui/styles/tokens.css";
import "@lucent/ui/styles/chrome.css";

const app = createApp(App);
app.use(router);

// Custom-element tags must be ignored by Vue's compiler so it doesn't
// try to resolve `lucent-insight` as a Vue component.
app.config.compilerOptions ??= {};
app.config.compilerOptions.isCustomElement = (tag) => tag === "lucent-insight";

// Inject the runtime bundle. Failures are non-fatal — the dashboard
// list/diff views still work without it; only the embedded view
// surfaces an error.
void bootstrapRuntime();

app.mount("#app");
